const messages = {
  fleetWithOptions: "Negalite pasirinkti parko, jei pasirinkote parinktis.",
  addProduct: "Jūsų produktas buvo pridėtas į krepšelį.",
  addProducts: "Jūsų produktai buvo pridėti į krepšelį.",
  profileSaved: "Jūsų profilio duomenys buvo išsaugoti.",
  canAddProduct: "Neturite pakankamai taškų.",
  customerNumberSaved: "Kliento numeris išsaugotas.",
  customerNumberExist: "Kliento numeris yra prieinamas.",
  complaintForm: "Jūsų užklausa priimta. Prašome palaukti atsakymo.",
  openHourSaved: "Darbo valandos išsaugotos.",
  changeParentId:
    "Negalite pakeisti filialo, kurio tėvo kliento numeris turi pavaldžias šakas.",
  requestSent: "Užklausa išsiųsta.",
  completeProfileRequired:
    "Norėdami tęsti apsipirkimą parduotuvėje, turite 100% užpildyti savo profilį.",
  accessDenied: "Prieiga uždrausta.",
  incomplete_address: "Adresas nebaigtas. Prašome patikrinti.",
  waitMoment: "Prašome palaukti.",
  downloadFinished: "Atsisiuntimas baigtas.",
  selectOneField: "Pasirinkite lauką.",
  noVoucher: "Kuponas nerastas.",
  cannotAddCsNumber: "Negalite pridėti kliento numerio.",
  messagesDeletedSuccess: "Žinutės buvo ištrintos.",
  messagesDeletedError: "Nepavyko ištrinti žinučių.",
  fillProfile: "Fill out the profile to be able to download the certificate,",
  favoriteAdded: "Pridėta prie mėgstamų.",
  favoriteRemoved: "Pašalinta iš mėgstamų.",
};

export default {
  messages,
};
